import { BlogCategoryEntityResponse } from '@/gql/generated/graphql'
import { formattedDate } from '@/utils/formattedDate'
import React from 'react'
import ResponsiveImage from '../core/ResponsiveImage'
import BlogPostsPagination from './BlogPostsPagination'
import { readingTime } from '@/utils/readingTime'
import PostAuthors from './PostAuthors'

type Props = {
  category: BlogCategoryEntityResponse
}

export default function CategoryPagePostsList(props: Props) {
  return (
    <section className='category-blog py-12 md:pt-[100px] md:pb-24 xl:pb-[366px]'>
      <div className='container'>
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 gap-y-14 sm:gap-y-20 lg:px-3 mb-12 md:mb-[100px]'>
          {props.category.data?.attributes?.posts?.data.filter(post => post.attributes?.publishedAt).map((post, index) => (
            <div key={post.id} className='item-block relative'>
              <a href={`/blog/${post.attributes?.slug}`} className='relative pt-[56.25%] block mb-5'>
                <ResponsiveImage className='absolute left-0 top-0 w-full h-full object-cover' image={post.attributes?.featureImage} />
              </a>
              <h3 className='font-roboto font-semibold text-xl leading-[1.4em] mb-8 md:min-h-[56px] sumon'>
                <a href={`/blog/${post.attributes?.slug}`} className='font-roboto font-semibold text-xl leading-[1.4em] transition-all hover:text-light-purple line-clamp-2'>
                  {post.attributes?.title}
                </a>
              </h3>
              <ul className='author-list flex flex-wrap gap-x-4'>
                <li className='font-roboto font-normal text-sm text-body-color'>
                  {post.attributes?.authors && !!post.attributes?.authors.data.length &&
                    <>
                      By{' '}
                      <PostAuthors authors={post.attributes?.authors} classNames='font-roboto font-normal text-sm text-body-color hover:text-light-purple' />
                    </>
                  }
                </li>
                <li className='font-roboto font-normal text-sm text-body-color'>{formattedDate(post.attributes?.publishedAt)}</li>
                <li className='font-roboto font-normal text-sm text-body-color'>{readingTime(post.attributes?.content ?? '')} min read</li>
              </ul>
            </div>
          ))}
        </div>
        {/* <BlogPostsPagination /> */}
      </div>
    </section>
  )
}
